@if (isStackedLayout && items?.length) {
    <ds-card variant="surface-lowest" [noBorderRadius]="false" [noBorder]="true" [elevated]="true">
        @for (item of items; track $index; let last = $last) {
            <ms-list-item
                msTrackReferringActionDirective
                iconSize="16"
                [trackingValue]="item.tracking"
                [cleanAfterTrack]="cleanedAfterTrack()"
                [title]="item.title"
                [icon]="item.sportsIcon ?? item.icon"
                [href]="item.href"
                [arrow]="false"
                [isShowBorder]="!last"
                [badge]="areBadgesEnabled(item)"
                (itemClicked)="clicked(item)">
                @if (item.colouredIcon) {
                    <span class="coloured-icon-alignment" item-icon>
                        <img [src]="item.colouredIcon" />
                    </span>
                }
            </ms-list-item>
        }
    </ds-card>
} @else {
    @if (items?.length) {
        @if (isCarouselLayout) {
            <ms-scroll-adapter size="medium" [scrollItems]="items">
                @if (isMiniCarouselLayout) {
                    <ul>
                        <li class="mini-carousel-layout">
                            <ng-container *ngTemplateOutlet="promoItemTemplate" />
                        </li>
                    </ul>
                } @else {
                    <ng-container *ngTemplateOutlet="promoItemTemplate" />
                }
            </ms-scroll-adapter>
        } @else {
            <ng-container *ngTemplateOutlet="promoItemTemplate" />
        }
    }

    <ng-template #promoItemTemplate>
        @for (item of items; track $index) {
            <ms-promo-item
                [layout]="layout"
                [title]="item.title"
                [icon]="item.icon"
                [arrow]="arrow"
                [href]="item.href"
                [popup]="item.popup"
                [leagueTitle]="item.leagueTitle"
                [leagueIcon]="item.leagueIcon"
                [sportsIcon]="item.sportsIcon"
                [ngClass]="itemClass"
                [class.us-logo]="hasCompetitionLogo(item)"
                [class.has-bgcolor]="hasBgcolorForTilesOrGridView(item)"
                [ngStyle]="hasBgcolorForTilesOrGridView(item) ? { 'background-color': item.bgColor, 'border-color': item.bgColor } : {}"
                [tracking]="item.tracking || 'M2_quicklinks'"
                [badgesEnabled]="areBadgesEnabled(item)"
                (click)="clicked(item)">
                @if (hasCompetitionLogo(item)) {
                    <ms-competition-logo
                        item-icon
                        [sportId]="item.sportId"
                        [leagueId]="item.leagueId"
                        [fallbackIcon]="item.icon"
                        [ngClass]="{ 'expand-logo': !item.title }" />
                }

                @if (item.colouredIcon) {
                    <img item-coloured-icon class="coloured-icon" [src]="item.colouredIcon" />
                }
            </ms-promo-item>
        }
    </ng-template>
}
